export class StaticHandlers {

    // Método para manejar eventos de teclado
    static handleKeyDown(event: KeyboardEvent, patternStr?: string) {
      const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
      const _pattern = patternStr ? new RegExp(`[${patternStr}]`) : /^[0-9A-ZÑ.,;_\-\/()\s]*$/;
      const key = event.key.toUpperCase();      

      if (!allowedKeys.includes(key) && !_pattern.test(key)) {
        event.preventDefault();
      }
    }
  
    // Método para manejar eventos de pegado
    static handlePaste(event: ClipboardEvent, patternStr?: string) {
      const clipboardData = event.clipboardData || window['clipboardData'];
      const pastedText = clipboardData.getData('text').toUpperCase();      
      const _pattern = patternStr ? new RegExp(`[${patternStr}]`) : /^[0-9A-ZÑ.,;_\-\/()\s]*$/;
  
      if (!_pattern.test(pastedText)) {
        event.preventDefault();
      }
    }
  
    static handleInput(event: Event) {
      const input = event.target as HTMLInputElement;
      input.value = input.value.toUpperCase();
      // Aquí debes asegurarte de que `emergencyDischargeForm` esté disponible en el contexto adecuado
      // this.emergencyDischargeForm.get('condDescDesc')?.setValue(input.value);
    }


    static handleBlurFill(event: Event, size: number, character: string): void {
      const input = event.target as HTMLInputElement;
      if (input.value.length < 6) {
          input.value = input.value.padStart(size, character);
      }
    }
    
  }